import { cn as e } from "../../../utils/utils.mjs";
import { forwardRef as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Root as i, Slottable as a } from "@radix-ui/react-slot";
import { cva as o } from "class-variance-authority";
//#region src/components/atoms/IconButton/IconButton.tsx
var s = o("p-3 flex items-center justify-center rounded-capsule outline-offset-2 focus:outline-blue-600 hover:cursor-pointer", { variants: {
	variant: {
		secondary: "bg-gray-800 hover:bg-gray-900 text-gray-200",
		transparent: "bg-transparent text-gray-900"
	},
	size: {
		small: "size-8 p-2.5",
		default: "size-10",
		large: "size-14"
	},
	disabled: { true: "bg-gray-200 text-gray-500 focus:outline-none hover:bg-gray-200 hover:text-gray-500 hover:cursor-not-allowed" }
} }), c = o("fill-current hover:fill-current", { variants: { size: {
	small: "size-3",
	default: "size-4",
	large: "size-4"
} } }), l = t(({ className: t = "", children: o, variant: l = "secondary", size: u = "default", disabled: d = !1, icon: f, asChild: p, ...m }, h) => {
	let g = e(s({
		variant: l,
		size: u,
		disabled: d
	}), t), _ = /* @__PURE__ */ n("div", {
		"data-testid": "icon-button-icon-container",
		className: e(c({ size: u })),
		children: f
	});
	return /* @__PURE__ */ r(p ? i : "button", {
		"data-testid": "icon-button",
		title: "Icon button",
		className: g,
		disabled: d,
		...m,
		ref: h,
		children: [/* @__PURE__ */ n(a, { children: o }), _]
	});
});
l.displayName = "IconButton";
//#endregion
export { l as IconButton };
